import { BROWSER_SESSION } from '~/types'

import type { WithOptions } from '../useInternalApi'

import { useInternalApi } from '../useInternalApi'

export type TemplateLanguageData = App.Http.InternalApi.BrowsingSession.Data.Template.LanguageData

export const useFetchLanguage = () => {
  const { get, getUrl } = useInternalApi()

  const getAll = ({ options }: WithOptions = {}) =>
    get<TemplateLanguageData[]>({
      url: getUrl(BROWSER_SESSION, 'languages'),
      accessType: BROWSER_SESSION,
      options,
    }).then(res => res.data)

  return {
    getAll,
  }
}
